import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { Chip as MuiChips } from '@material-ui/core';

import { colors } from '../../theme/colors';

const useStyles = makeStyles({
  root: {
    backgroundColor: colors.green4,
  },
  outlined: {
    backgroundColor: 'transparent',
    borderColor: colors.green4,
  },
});

const Chips = ({ ...props }) => {
  const classes = useStyles();

  return <MuiChips classes={classes} {...props} />;
};

export { Chips };
